import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import useExternalApiService from "helpers/ExternalApiService";
import { store } from 'stores/Store';

import { init, logEvent, setUserId } from '@amplitude/analytics-browser';

const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY!;

export default function ProtectedRoute({ children }: any) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { postData, getData } = useExternalApiService(process.env.REACT_APP_EAI_URL);
  const navigate = useNavigate();

  useEffect(() => {
    const initializeUser = async () => {
      if (isAuthenticated && !store.user) {
        try {
          //console.time("user-api-call");
          const [result, profile] = await Promise.all([
            postData('/api/get_user', {}),
            getData('/api/e/call_winback_get_user_impersonate_list')
          ]);
          //console.timeEnd("user-api-call");

          store.setRefreshDataTime(profile.t_historical_version);
          store.setUser({
            userFriendlyName: `${result.user_info.first_name ?? 'Your'} ${result.user_info.last_name ?? 'Name'}`,
            userName: result.user_info.user_name,
            userPicture: result.user_info.icon_url,
            impersonateList: profile.fmc_list,
            isAdmin: profile.is_admin,
            earlyRelease: profile.early_release
          });

          if (profile.is_admin) {
            store.setImpersonatedUser(profile.fmc_list[0]);
            store.setAnswers(`## Good ${store.getTimeGreeting()}, ${profile.fmc_list[0] ?? ''} \n I'm your Sales AI.  Here are some things I can do:`);
          } else {
            store.setImpersonatedUser(result.user_info.user_name);
            store.setAnswers(`## Good ${store.getTimeGreeting()}, ${result.user_info.first_name ?? ''} \n I'm your Sales AI.  Here are some things I can do:`);
          }

          console.log("Setting amplitude user_name:", result.user_info.user_name);
          init(AMPLITUDE_KEY, result.user_info.user_name, {
              autocapture: {
                pageViews: false, 
                elementInteractions: true, 
            }
          });          
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      }
    };

    if (!isLoading) {
      if (isAuthenticated) {
        initializeUser();
        //console.log("Logging Amplitude userName:", store.user?.userName);
        //setUserId(store.user?.userName);        
        //const userName =  store?.impersonatedUser + " authenticated";
        //logEvent(userName);
        /*logEvent('User Login', { 
          user: store.user?.userName,
          user_id: store.user?.userName,
          viewedUserName: store?.impersonatedUser,
          friendlyName: store.user?.userFriendlyName
        });*/
      } else {
        loginWithRedirect({
          appState: {
            returnTo: "/",
          },
        });
      }
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  return (
    (isLoading || !isAuthenticated) ?
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div>Loading...</div>
      </div> : children
  )


}

